import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/firestore'
import config from '../config/config';


firebase.initializeApp(config.FIREBASE_CONFIG)

export const database = firebase.database()
export const firestore = firebase.firestore()

const settings = { /* your settings... */ timestampsInSnapshots: true }
firestore.settings(settings)



// WEBPACK FOOTER //
// ./src/lib/firebase.js